import { Pipe, PipeTransform } from "@angular/core";
import { DateTime } from "luxon";

@Pipe({name: 'dateValue'})
export class DateValuePipe implements PipeTransform {
    transform(value: string, fromFormat = 'yyyy-MM-dd', toFormat = 'dd MMM yyyy') {
      let dateTime = fromFormat !== 'ISO' ? DateTime.fromFormat(value, fromFormat) : DateTime.fromISO(value);
      return dateTime.toFormat(toFormat);
    }
}